// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:41:41

export default {
  "id": "lambo-traffic-racer",
  "slug": "lambo-traffic-racer",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ab3a6a3d3c534770b4a3a91fff18df2b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ab3a6a3d3c534770b4a3a91fff18df2b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Lambo Traffic Racer",
      "description": "Lambo Traffic Racing, you will be playing lambo cars through endless highway. It is a great game for kids and adults. Great fun, great graphics and great lambos to drive .",
      "instructions": "W, A, S, D/ Arrow Keys: Drive/Steer/Brake , F: Nitro , C: Change Camera",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "兰博交通赛车",
      "description": "劳博交通赛车，你将驾驶劳博车在无尽的公路上竞技。这是一款适合儿童和成人的优秀游戏。极具乐趣，画面精美，驾驶体验非凡的劳博车。",
      "instructions": "W, A, S, D/方向键：前进/转向/刹车，F：氮气，C：切换摄像头",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "1玩家"
      ]
    },
    "zh-TW": {
      "title": "賓士交通賽車",
      "description": "Lambo Traffic Racing，你將駕馭著Lambo車款在無盡的高速公路上競速。這是一款適合兒童和成人玩的不錯遊戲。非常有趣，圖形出色，還有許多Lambo車款可供駕馭。",
      "instructions": "W, A, S, D / 方向鍵：駕駛/操縱/煞車，F：氮氣，C：切換鏡頭",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "賓士交通競速",
      "description": "Lambo Traffic Racing，你將會駕駛Lambo車輛穿梭於無盡的高速公路上。這是一款適合大人和小朋友玩的好遊戲。好玩、圖像出色、駕駛感極佳的Lambo車輛。",
      "instructions": "W, A, S, D / 方向鍵：駕駛/操控/煞車，F：氮氣，C：切換鏡頭",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "ランボ・トラフィックレーサー",
      "description": "ランボ・トラフィックレーシング、無限の高速道路をランボ車で走らせるゲームです。子どもも大人も楽しめる素晴らしいゲームです。楽しい遊び、素晴らしいグラフィック、運転するのに最適なランボ車たち。",
      "instructions": "W, A, S, D / アーカイブキー: ドライブ/ハンドル/ブレーキ、F: ニトロ、C: カメラ切替",
      "genres": [
        "レース & ドライビング"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "람보 트래픽 레이서",
      "description": "램보 트래픽 레이싱, 무한한 고속도로에서 램보 차량을 타고 달리는 게임입니다. 아이들과 성인들에게도 좋은 게임입니다. 흥미진진한 재미, 뛰어난 그래픽, 드릴만한 램보 차량입니다.",
      "instructions": "W, A, S, D / 방향키: 드라이브/스테어링/브레이크, F: 니트로, C: 캠에러 변경",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Lambo Traffic Racer\nCourse de trafic Lamborghini",
      "description": "Lambo Traffic Racing, vous allez piloter des Lamborghini sur une autoroute infinie. C'est un excellent jeu pour les enfants et les adultes. Beaucoup de fun, de superbe graphismes et des Lamborghini incroyables à conduire.",
      "instructions": "W, A, S, D/Touches directionnelles: Direction/Conduite/Frein , F: Nitro , C: Changer de caméra",
      "genres": [
        "Courses et conduite"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
